var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header__util"},[_c('router-link',{class:['header__util-anchor', {'is-active': _vm.isActive}],attrs:{"to":_vm.to,"aria-selected":("" + _vm.isActive)},nativeOn:{"click":function($event){return _vm.activeUpdate.apply(null, arguments)}}},[_vm._v("About")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67390e01","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-header/header-util.vue
// module id = null
// module chunks = 